module.exports = __webpack_public_path__ + "static/img/pic_coop01.76a4879.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/anchorOperation/channelPlanning/pic_coop01.png
// module id = CFK8
// module chunks = 0